<ll-toolnavbar>
    <banner-toolnavbar></banner-toolnavbar>
</ll-toolnavbar>
<ll-titulo>Instancias del Banner</ll-titulo>

<banner_instancias [bannerId]="bannerId" listRoute="banners"></banner_instancias>
